__turbopack_context__.v({
  "articlesSectionContainer": "BlogHome-module-scss-module__BCPcHG__articlesSectionContainer",
  "blogPostsContainer": "BlogHome-module-scss-module__BCPcHG__blogPostsContainer",
  "blogPostsLinkGrid": "BlogHome-module-scss-module__BCPcHG__blogPostsLinkGrid",
  "filters": "BlogHome-module-scss-module__BCPcHG__filters",
  "filtersItem": "BlogHome-module-scss-module__BCPcHG__filtersItem",
  "filtersItemCurrent": "BlogHome-module-scss-module__BCPcHG__filtersItemCurrent",
  "filtersItemLink": "BlogHome-module-scss-module__BCPcHG__filtersItemLink",
  "filtersList": "BlogHome-module-scss-module__BCPcHG__filtersList",
  "pagination": "BlogHome-module-scss-module__BCPcHG__pagination",
  "paginationControl": "BlogHome-module-scss-module__BCPcHG__paginationControl",
  "paginationItem": "BlogHome-module-scss-module__BCPcHG__paginationItem",
  "paginationItemActive": "BlogHome-module-scss-module__BCPcHG__paginationItemActive",
  "paginationItemMobile": "BlogHome-module-scss-module__BCPcHG__paginationItemMobile",
  "paginationItemSm": "BlogHome-module-scss-module__BCPcHG__paginationItemSm",
  "paginationLink": "BlogHome-module-scss-module__BCPcHG__paginationLink",
});
